
<template>
  <vs-popup
    class="holamundo"
    popup-class="w-9/12"
    :title="title"
    :active.sync="popupActive"
  >
    <form id="formStepStart" data-vv-scope="step-start">
      <div class="vx-row mb-5 w-full">
        <div class="vx-col flex-inline w-full" v-if="customSetting.name">
          <label>
            {{
              CustomSettingName[customSetting.name].title +
              "-" +
              CustomSettingName[customSetting.name].name
            }}
          </label>
          <template
            v-if="CustomSettingName[customSetting.name].type === Boolean"
          >
            <vs-switch color="success" v-model="customSetting.value">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </template>
          <template
            v-else-if="CustomSettingName[customSetting.name].type === Number"
          >
            <vs-input
              v-model="customSetting.value"
              inputmode="numeric"
              class="w-full ltr-input"
            />
          </template>
          <template v-else>
            <vs-textarea
              v-model="customSetting.value"
              rows="6"
              inputmode="numeric"
              class="w-full"
              :class="{ 'ltr-input': ltrInput }"
            />
            <div class="vx-row mb-5 w-full">
              <div class="vx-col flex-inline">راست به چپ:</div>
              <div class="vx-col flex-inline">
                <vs-switch color="success" v-model="ltrInput">
                  <span slot="on">ON</span>
                  <span slot="off">OFF</span>
                </vs-switch>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
            >ذخیره</vs-button
          >
          <vs-button
            color="warning"
            type="border"
            class="mb-2"
            @click="commissionGroup = {}"
            >پاک کردن</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
</style>
<script>
import { CustomSettingName } from "@/enums.js";
import vSelect from "vue-select";

export default {
  name: "edit-custom-setting",
  props: {},
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      CustomSettingName,
      popupActive: false,
      customSetting: {},
      title: "",
      ltrInput: true,
    };
  },
  methods: {
    submitForm() {
      let loading = this.$vs.loading();
      this.$http
        .post(
          "/api/services/app/CustomSetting/CreateOrEdit",
          this.customSetting
        )
        .then((response) => {
          if (response.data.success == true) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "‌کارمزد با موفقیت ذخیره شد",
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id, name) {
      this.customSetting = {};
      if (id) {
        this.title =
          'ویرایش  "' +
          CustomSettingName[name].title +
          "-" +
          CustomSettingName[name].name +
          '"';
        this.get(id);
      } else {
        return;
      }
      this.popupActive = true;
    },
    async get(id) {
      let loading = this.$vs.loading();

      let payload = {
        params: {
          id: id,
        },
      };
      this.$http
        .get("/api/services/app/CustomSetting/GetCustomSettingForEdit", payload)
        .then(async (response) => {
          this.customSetting = response.data.result;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          this.$vs.loading.close();
        }); //end http
    },
  },
  mounted() {},
};
</script>